var _defs, _path, _line, _line2, _line3, _line4, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeteorology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.44 97.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-met{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-met",
    d: "M248.18,1328.73A19.09,19.09,0,1,1,282.46,1312",
    transform: "translate(-222.3 -1277.47)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-met",
    x1: 41.94,
    y1: 3,
    x2: 41.94,
    y2: 15.14
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-met",
    x1: 16.03,
    y1: 13.36,
    x2: 24.61,
    y2: 21.95
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-met",
    x1: 69.02,
    y1: 13.36,
    x2: 60.44,
    y2: 21.95
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-met",
    x1: 15.14,
    y1: 40.47,
    x2: 3,
    y2: 40.47
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-met",
    d: "M306.43,1345.58a26.27,26.27,0,0,0-50.9-8.22,17.43,17.43,0,0,0,2.55,34.67h47.41a13.24,13.24,0,0,0,.94-26.45Z",
    transform: "translate(-222.3 -1277.47)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeteorology);
export default __webpack_public_path__ + "static/media/Meteorology.4a6d0f639f37607fda6564341832c08f.svg";
export { ForwardRef as ReactComponent };